import types from "../actions";

const initialState = {};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.GET_DASHBOARD_REPORTS_REQUEST:
      return { ...state, dashboardReports: true }
    case types.GET_DASHBOARD_REPORTS_SUCCESS:
    case types.GET_DASHBOARD_REPORTS_FAILURE:
      return { ...state, dashboardReports: false }
    case types.SEARCH_REQUEST:
      return { ...state, search: true }
    case types.SEARCH_FAILURE:
    case types.ARTISTS_RESULT:
    case types.TRACKS_RESULT:
    case types.ALBUMS_RESULT:
    case types.CHANNELS_RESULT:
    case types.USERS_RESULT:
      return { ...state, search: false }
    case types.GET_ALL_CHANNELS_REQUEST:
    case types.DELETE_CHANNEL_REQUEST:
      return { ...state, channels: true }
    case types.GET_ALL_CHANNELS_FAILURE:
    case types.GET_ALL_CHANNELS_SUCCESS:
    case types.DELETE_CHANNEL_FAILURE:
    case types.DELETE_CHANNEL_SUCCESS:
      return { ...state, channels: false }
    case types.GET_HOME_REQUEST:
    case types.SAVE_HOME_REQUEST:
      return { ...state, home: true }
    case types.GET_HOME_SUCCESS:
    case types.GET_HOME_FAILURE:
    case types.SAVE_HOME_SUCCESS:
    case types.SAVE_HOME_FAILURE:
      return { ...state, home: false }
    case types.GET_CHANNEL_REQUEST:
      return { ...state, channel: action.id }
    case types.GET_CHANNEL_SUCCESS:
    case types.GET_CHANNEL_FAILURE:
      return { ...state, channel: false }
    case types.GET_ADS_LIST_REQUEST:
      return { ...state, ads: true }
    case types.GET_ADS_LIST_FAILURE:
    case types.GET_ADS_LIST_SUCCESS:
      return { ...state, ads: false }
    case types.GET_SINGLE_AD_REQUEST:
      return {
        ...state,
        ad: action.id
      }
    case types.GET_SINGLE_AD_FAILURE:
    case types.GET_SINGLE_AD_SUCCESS:
      return {
        ...state,
        ad: false
      }
    case types.DELETE_AD_REQUEST:
      return {...state, ad: action.data.id}
    case types.DELETE_AD_SUCCESS:
    case types.DELETE_AD_FAILURE:
      return {...state, ad: null}
      case types.SAVE_MEDIUM_REQUEST:
        return {
          ...state,
          medium: action.id
        }
      case types.SAVE_MEDIUM_SUCCESS:
      case types.SAVE_MEDIUM_FAILURE:
        return {
          ...state,
          medium: false
        }
    default:
      return state;
  }
}
